import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useGetCentersQuery } from '../../../../../services/ConfigurationService';
import { useAppSelector } from '../../../../../app/store';
import { AddCenterDialog } from '../../dialogs';
import { ContractCentersList } from '../../grids';

interface CentersTabProps {
  // No props needed - component manages its own state through Redux
}

export const CentersTab: React.FC<CentersTabProps> = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  
  // Get contract state from Redux for count display
  const contract = useAppSelector((state) => state.contract.currentContract);
  const selectedCenterViews = contract?.centers || [];
  
  // Fetch available centers for the company to get count
  const { 
    data: availableCenters = [], 
    isLoading, 
    error 
  } = useGetCentersQuery(
    { company }, 
    { skip: !company }
  );

  // Get selected center details count
  const selectedCenterCodes = selectedCenterViews.map(center => center.code);
  const selectedCenterCount = availableCenters.filter(center => 
    selectedCenterCodes.includes(center.code)
  ).length;

  if (!company) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">
          Company parameter is required to manage centers.
        </Typography>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography>Loading available centers...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">
          Error loading centers. Please try again.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h6">
          Contract Centers ({selectedCenterCount})
        </Typography>
        <AddCenterDialog />
      </Stack>

      {/* Selected Centers List */}
      <ContractCentersList />
    </Box>
  );
};
